module.exports = __webpack_public_path__ + "img/01-BABO-B-off.c6503d86.png";